import { PageType } from '../types/ContentOverlay';
import type { PageContentTypes } from '../types/ContentOverlay';

import {
  TXTCLI_End_User_License_Agreement,
  TXTCLI_Privacy_Policy,
  TXTMOB_Security_of_Account_Balances
} from './contentOverlay.messages.json';

export const pageContents = new Map<string, PageContentTypes>([
  [
    PageType.Eula,
    {
      link: 'tos',
      title: TXTCLI_End_User_License_Agreement
    }
  ],
  [
    PageType.Privacy,
    {
      link: 'privacy',
      title: TXTCLI_Privacy_Policy
    }
  ],
  [
    PageType.PFP,
    {
      link: 'about/account-balance-security/',
      title: TXTMOB_Security_of_Account_Balances
    }
  ]
]);
